import { Link } from "react-router-dom";

const LinkItem = ({ to, children, testId }) => (
    <li>
        <Link to={to} data-testid={testId} className="hover:text-holo transition-colors">{children}</Link>
    </li>
);

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="mt-32 border-t border-black/5 bg-[#FAFAF7]">
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid md:grid-cols-4 gap-10">
                <div className="md:col-span-2">
                    <div className="overline text-[#5C5C5C]">Instituto de</div>
                    <div className="font-display text-2xl tracking-tight mt-1">Medicina Quântica</div>
                    <p className="font-body text-[#5C5C5C] mt-4 max-w-md">
                        Streaming premium de transformação, consciência e medicina integrativa. Jornadas guiadas por mentores referência no Brasil.
                    </p>
                </div>
                <div>
                    <div className="overline text-[#5C5C5C] mb-4">Plataforma</div>
                    <ul className="font-body space-y-2 text-[#1A1A1A]">
                        <LinkItem to="/jornadas" testId="footer-journeys">Jornadas</LinkItem>
                        <LinkItem to="/biblioteca" testId="footer-library">Biblioteca</LinkItem>
                        <LinkItem to="/mentores" testId="footer-mentors">Mentores</LinkItem>
                        <LinkItem to="/certificados" testId="footer-certificates">Certificados</LinkItem>
                        <LinkItem to="/planos" testId="footer-plans">Planos</LinkItem>
                    </ul>
                </div>
                <div>
                    <div className="overline text-[#5C5C5C] mb-4">Instituto</div>
                    <ul className="font-body space-y-2 text-[#1A1A1A]">
                        <LinkItem to="/sobre" testId="footer-about">Sobre</LinkItem>
                        <LinkItem to="/contato" testId="footer-contact">Contato</LinkItem>
                        <LinkItem to="/termos" testId="footer-terms">Termos</LinkItem>
                        <LinkItem to="/privacidade" testId="footer-privacy">Privacidade</LinkItem>
                    </ul>
                </div>
            </div>
            <div className="border-t border-black/5">
                <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 text-xs font-body text-[#5C5C5C] flex flex-wrap gap-3 justify-between">
                    <span>© {new Date().getFullYear()} Instituto Medicina Quântica</span>
                    <span className="font-editorial italic">Onde a consciência encontra a ciência.</span>
                </div>
            </div>
        </footer>
    );
}
